const SHOP_INFO = 'info';
const REVIEWS = 'opiniones';
const SEARCH = 'buscar';
const SECTION = 'seccion';

export const isShopInfoRoute = pathname =>
  pathname ? pathname.endsWith(SHOP_INFO) : false;

export const isShopDetailsReviewRoute = pathname =>
  pathname ? pathname.endsWith(REVIEWS) : false;

export const isShopDetailsSearchRoute = pathname =>
  pathname ? pathname.endsWith(SEARCH) : false;

export const isShopDetailsSectionRoute = pathname =>
  pathname ? pathname.includes(SECTION) : false;

export const modalActive = pathname => {
  let isActive = false;
  if (
    isShopInfoRoute(pathname) ||
    isShopDetailsReviewRoute(pathname) ||
    isShopDetailsSearchRoute(pathname) ||
    isShopDetailsSectionRoute(pathname)
  )
    isActive = true;
  return isActive;
};
